import { api } from '../plugins/axios';
import {
  TOrderDetail,
  OrderHistorySearchOption,
  OrderPayStarting,
  OrderReady,
  OrderResult,
  OrderStart,
  OrderSummary,
  Paged,
  TResponse,
  OrderCancelRequest,
  OrderRequestRequestDto,
  OrderRequestCreateDto,
  OrderRequestPrepaidDto,
  OrderHistoryQueryRequest,
  OrderChangeAddressDto,
  OrderChangeSizeDto,
  OrderDiscountRequest,
  CouponApplyResult,
} from '../types/types';

export const postOrders = (data: string[]) => {
  return api.post(`/v1/orders`, data);
};

export const getOrders = () => {
  return api.get<TResponse<OrderReady>>(`/v1/orders`);
};

export const getOrderHistory = (
  page: number,
  size: number,
  options?: OrderHistorySearchOption,
) => {
  const params = { page, size, ...options };
  return api
    .get<TResponse<Paged<OrderSummary>>>(`/v1/orders/histories`, { params })
    .catch(e => console.log('getOrderHistory e : ', e));
};

export const getOrderHistoryDetail = (orderNumber: string) => {
  return api.get<TResponse<TOrderDetail>>(
    `/v1/orders/histories/${orderNumber}`,
  );
};

export const getNotUserOrderDetail = (
  orderNumber: string,
  data: { customerName: string; customerPhone: string },
) => {
  return api.post<TResponse<TOrderDetail>>(
    `/v1/orders/histories/${orderNumber}`,
    data,
  );
};

export const getCanceledOrderHistory = (
  page: number,
  size: number,
  options?: OrderHistorySearchOption,
) => {
  const params = { page, size, ...options };
  return api.get<TResponse<Paged<OrderSummary>>>(
    `/v1/orders/histories/cancel`,
    { params },
  );
};

export const getReturnedOrderHistory = (
  page: number,
  size: number,
  options?: OrderHistorySearchOption,
) => {
  const params = { page, size, ...options };
  return api.get<TResponse<Paged<OrderSummary>>>(
    `/v1/orders/histories/return`,
    { params },
  );
};

export const orderPaymentStart = (
  orderNumber: string,
  data: OrderPayStarting,
) => {
  const url = `/v1/orders/payments/${orderNumber}`;
  return api.post<TResponse<OrderStart>>(url, data);
};

export const orderConfirm = (data: any) => {
  const nData = new FormData();
  for (let key in data) {
    nData.append(key, data[key]);
  }
  return api.post<TResponse<OrderResult>>(
    '/v1/orders/payments/confirm',
    nData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};

export const orderCancel = (orderNumber: string, data?: OrderCancelRequest) => {
  const url = `/v1/orders/payments/${orderNumber}/cancel`;
  return api.post(url, data);
};

export const orderRequestPrePaid = (
  orderNumber: string,
  data: OrderRequestRequestDto,
) => {
  const url = `/v1/orders/requests/${orderNumber}/pre-paid`;
  return api.post<TResponse<OrderRequestPrepaidDto>>(url, data);
};

export const orderRequestCreate = (
  orderNumber: string,
  data: OrderRequestCreateDto,
) => {
  const url = `/v1/orders/requests/${orderNumber}`;
  return api.post<TResponse<OrderStart>>(url, data);
};

export const orderRequestConfirm = (data: any) => {
  const nData = new FormData();
  for (let key in data) {
    nData.append(key, data[key]);
  }
  return api.post(`/v1/orders/requests/confirm`, nData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const orderFinalConfirm = (
  orderNumber: string,
  data: OrderHistoryQueryRequest,
) => {
  return api.post(`/v1/orders/confirms/${orderNumber}`, data);
};

export const nonMemberOrderHistories = (
  orderNumber: string,
  data: OrderHistoryQueryRequest,
) => {
  const url = `/v1/orders/histories/${orderNumber}`;
  return api.post<TResponse<TOrderDetail>>(url, data);
};

export const changeShippingAddress = (
  orderNumber: string,
  data: OrderChangeAddressDto,
) => {
  const url = `/v1/orders/change/${orderNumber}/address`;
  return api.post<TResponse<void>>(url, data);
};

export const changeSizeBeforeShip = (
  orderNumber: string,
  data: OrderChangeSizeDto,
) => {
  const url = `/v1/orders/change/${orderNumber}/size`;
  return api.post<TResponse<void>>(url, data);
};

export const getCouponDiscountPrice = (
  orderNumber: string,
  data: OrderDiscountRequest,
) => {
  const url = `/v1/orders/${orderNumber}/discount`;
  return api.post<TResponse<CouponApplyResult>>(url, data);
};

export const cancelOrderRequest = (
  orderNumber: string,
  data: OrderCancelRequest,
) => {
  const url = `/v1/orders/requests/${orderNumber}/cancel`;
  return api.post<TResponse<void>>(url, data);
};

export const orderChangeAvailable = (orderNumber: string) => {
  const url = `/v1/orders/change/${orderNumber}/available`;
  return api.get<TResponse<void>>(url);
};

export const returnStock = () => {
  const url = '/v1/orders/returnStock';
  return api.get<TResponse<void>>(url);
};

export const changeRequestShippingAddress = (
    orderNumber: string,
    data: OrderChangeAddressDto,
) => {
  const url = `/v1/orders/requests/${orderNumber}/address`;
  return api.post<TResponse<void>>(url, data);
};
